import React from "react";

export const UndrawWireframing = ({ className }) => {
  return (
    <svg
      id="adf6e2ad-667e-4933-ac27-50a949c2abe5"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1130"
      height="799.21"
      viewBox="0 0 1130 799.21"
      className={className}
    >
      <defs>
        <linearGradient
          id="868cab57-2b4d-4e57-8adc-c5cfcad099b7"
          x1="784.71"
          y1="837.27"
          x2="784.71"
          y2="420.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="gray" stopOpacity="0.25" />
          <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
          <stop offset="1" stopColor="gray" stopOpacity="0.1" />
        </linearGradient>
      </defs>
      <title>wireframing</title>
      <path
        d="M1143.14,248.05a231.37,231.37,0,0,0-44.83-60.38l-621.86-5.18,512-60.79a337.39,337.39,0,0,0-103.88-17.42C835.28,70.63,771.93,50.4,702.83,50.4c-62,0-119.33,16.29-166.07,43.93C497,77,451.74,67.21,403.65,67.21c-138.17,0-253.3,80.9-279.13,188.19Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
        opacity="0.1"
      />
      <path
        d="M1165,338a197,197,0,0,0-19.38-84.92L67.86,348.75a209.69,209.69,0,0,0-25.25,53.91l333.75,42.06L35,475.39C45.27,596.84,168.43,692.75,318.88,692.75c75.73,0,144.54-24.31,195.53-63.94C565.56,669.19,635,694,711.58,694c113.57,0,211.6-54.67,257.25-133.72,91.58-24.57,162.72-86.28,187.07-163.46L733.83,341.5H1165C1165,340.35,1165,339.19,1165,338Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
        opacity="0.1"
      />
      <path
        d="M318.42,603.47s-46.22-66.69-38.37-129.63a122.94,122.94,0,0,0-14.8-76.34,206.71,206.71,0,0,0-21.74-30.94"
        transform="translate(-35 -50.4)"
        fill="none"
        stroke="#535461"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M248.22,326.87c3,9.05-4.71,40.74-4.71,40.74s-25.09-20.83-28.09-29.89a17.27,17.27,0,0,1,32.8-10.85Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M291.92,368.06c-2.4,9.23-26.09,31.64-26.09,31.64s-9.74-31.12-7.33-40.35a17.27,17.27,0,1,1,33.42,8.71Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M319.11,454.17c-6.74,6.76-38.5,14.14-38.5,14.14s7.31-31.78,14-38.53a17.27,17.27,0,0,1,24.46,24.39Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M325,524c-5.5,7.79-35.56,20.44-35.56,20.44s1.83-32.56,7.33-40.35A17.27,17.27,0,0,1,325,524Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M232,412.85c8.58,4.16,41,.68,41,.68s-17.36-27.6-26-31.77A17.27,17.27,0,0,0,232,412.85Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M239.91,494.38c9.44,1.4,39.34-11.62,39.34-11.62S254.42,461.61,245,460.21a17.27,17.27,0,1,0-5.08,34.17Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M258.49,572.56c9.07,3,40.74-4.8,40.74-4.8s-20.9-25-30-28a17.27,17.27,0,1,0-10.78,32.82Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M248.22,326.87c3,9.05-4.71,40.74-4.71,40.74s-25.09-20.83-28.09-29.89a17.27,17.27,0,0,1,32.8-10.85Z"
        transform="translate(-35 -50.4)"
        opacity="0.25"
      />
      <path
        d="M291.92,368.06c-2.4,9.23-26.09,31.64-26.09,31.64s-9.74-31.12-7.33-40.35a17.27,17.27,0,1,1,33.42,8.71Z"
        transform="translate(-35 -50.4)"
        opacity="0.25"
      />
      <path
        d="M319.11,454.17c-6.74,6.76-38.5,14.14-38.5,14.14s7.31-31.78,14-38.53a17.27,17.27,0,0,1,24.46,24.39Z"
        transform="translate(-35 -50.4)"
        opacity="0.25"
      />
      <path
        d="M325,524c-5.5,7.79-35.56,20.44-35.56,20.44s1.83-32.56,7.33-40.35A17.27,17.27,0,0,1,325,524Z"
        transform="translate(-35 -50.4)"
        opacity="0.25"
      />
      <path
        d="M232,412.85c8.58,4.16,41,.68,41,.68s-17.36-27.6-26-31.77A17.27,17.27,0,0,0,232,412.85Z"
        transform="translate(-35 -50.4)"
        opacity="0.25"
      />
      <path
        d="M239.91,494.38c9.44,1.4,39.34-11.62,39.34-11.62S254.42,461.61,245,460.21a17.27,17.27,0,1,0-5.08,34.17Z"
        transform="translate(-35 -50.4)"
        opacity="0.25"
      />
      <path
        d="M258.49,572.56c9.07,3,40.74-4.8,40.74-4.8s-20.9-25-30-28a17.27,17.27,0,1,0-10.78,32.82Z"
        transform="translate(-35 -50.4)"
        opacity="0.25"
      />
      <path
        d="M318.16,600.79s-69.28-42.24-87.62-103A123,123,0,0,0,186.08,434a206.69,206.69,0,0,0-32.41-19.47"
        transform="translate(-35 -50.4)"
        fill="none"
        stroke="#535461"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M141.89,376.37c6.41,7.06,12.2,39.15,12.2,39.15s-31.37-8.88-37.78-15.94a17.27,17.27,0,1,1,25.58-23.21Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M198.54,396.31c1.54,9.42-11,39.51-11,39.51S166,411.31,164.45,401.89a17.27,17.27,0,0,1,34.09-5.58Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M258.29,464c-3.43,8.91-29.47,28.53-29.47,28.53s-6.2-32-2.78-40.92A17.27,17.27,0,1,1,258.29,464Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M292,525.43c-1.87,9.36-24.23,33.1-24.23,33.1s-11.52-30.51-9.65-39.86A17.27,17.27,0,1,1,292,525.43Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M161.88,461.55c9.54.33,37.77-16,37.77-16S172.6,427.35,163.06,427a17.27,17.27,0,0,0-1.18,34.52Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M202.17,532.87c9.2-2.54,31.26-26.56,31.26-26.56S202.16,497,193,499.58a17.27,17.27,0,1,0,9.2,33.29Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M250.84,596.82c9.5-1,35.3-20.9,35.3-20.9s-29.25-14.42-38.74-13.47a17.27,17.27,0,0,0,3.44,34.37Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <ellipse
        cx="565.71"
        cy="734.08"
        rx="179"
        ry="10.62"
        fill="#59d3ff"
        opacity="0.1"
      />
      <ellipse
        cx="746.87"
        cy="781.25"
        rx="46.86"
        ry="8.53"
        fill="#59d3ff"
        opacity="0.1"
      />
      <path
        d="M683,765.81v6.41H493.38V767a62.33,62.33,0,0,0,4.29-115.12H681.75A62.37,62.37,0,0,0,683,765.81Z"
        transform="translate(-35 -50.4)"
        fill="#c8cad7"
      />
      <path
        d="M681.75,651.89a62.43,62.43,0,0,0-34.46,41.33H532.13a62.43,62.43,0,0,0-34.46-41.33Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M276.21,619.22v36c0,19.88,14.55,36,32.5,36h558c17.95,0,32.5-16.12,32.5-36v-36Z"
        transform="translate(-35 -50.4)"
        fill="#c8cad7"
      />
      <path
        d="M683,765.81v6.41H493.38V767A62.2,62.2,0,0,0,508,759.22h163.4A62.47,62.47,0,0,0,683,765.81Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <rect
        x="395.71"
        y="710.82"
        width="315"
        height="19"
        rx="9.5"
        ry="9.5"
        fill="#c8cad7"
      />
      <path
        d="M899.21,224.72a32.5,32.5,0,0,0-32.5-32.5h-558a32.5,32.5,0,0,0-32.5,32.5v401.5h623Z"
        transform="translate(-35 -50.4)"
        fill="#474157"
      />
      <rect
        x="258.21"
        y="172.82"
        width="589"
        height="377"
        rx="16"
        ry="16"
        fill="#ededf4"
      />
      <circle cx="552.71" cy="157.32" r="7.5" fill="#fff" />
      <circle cx="552.71" cy="606.32" r="18.5" fill="#fff" />
      <path
        d="M882.21,239.22h-589a16,16,0,0,1,16-16h557A16,16,0,0,1,882.21,239.22Z"
        transform="translate(-35 -50.4)"
        fill="#c8cad7"
      />
      <circle cx="274.21" cy="180.82" r="4" fill="#ededf4" />
      <circle cx="286.21" cy="180.82" r="4" fill="#ededf4" />
      <circle cx="298.21" cy="180.82" r="4" fill="#ededf4" />
      <rect x="280.21" y="202.32" width="151" height="9" fill="#59d3ff" />
      <rect x="280.21" y="465.32" width="151" height="9" fill="#59d3ff" />
      <rect
        x="280.21"
        y="485.32"
        width="280"
        height="9"
        fill="#59d3ff"
        opacity="0.2"
      />
      <rect
        x="280.21"
        y="498.33"
        width="280"
        height="9"
        fill="#59d3ff"
        opacity="0.2"
      />
      <rect
        x="280.21"
        y="511.33"
        width="280"
        height="9"
        fill="#59d3ff"
        opacity="0.2"
      />
      <rect
        x="280.21"
        y="226.32"
        width="278"
        height="151"
        fill="#59d3ff"
        opacity="0.2"
      />
      <rect
        x="283.21"
        y="391.32"
        width="65"
        height="60"
        fill="#59d3ff"
        opacity="0.2"
      />
      <rect
        x="493.21"
        y="391.32"
        width="65"
        height="60"
        fill="#59d3ff"
        opacity="0.2"
      />
      <rect
        x="386.71"
        y="391.32"
        width="65"
        height="60"
        fill="#59d3ff"
        opacity="0.2"
      />
      <rect
        x="617.55"
        y="270.24"
        width="191.33"
        height="140.83"
        fill="#59d3ff"
        opacity="0.2"
      />
      <rect x="637.71" y="298.82" width="151" height="9" fill="#ededf4" />
      <rect x="637.71" y="317.49" width="151" height="9" fill="#ededf4" />
      <rect x="637.71" y="336.16" width="151" height="9" fill="#ededf4" />
      <rect x="637.71" y="354.82" width="151" height="9" fill="#ededf4" />
      <rect x="637.71" y="373.49" width="151" height="9" fill="#ededf4" />
      <rect
        x="640.88"
        y="427.07"
        width="144.67"
        height="25.33"
        fill="#59d3ff"
      />
      <rect x="633.15" y="511.47" width="97.01" height="16.99" fill="#59d3ff" />
      <ellipse
        cx="258.43"
        cy="775.37"
        rx="28.6"
        ry="2.9"
        fill="#59d3ff"
        opacity="0.1"
      />
      <ellipse
        cx="843.87"
        cy="733.9"
        rx="17.14"
        ry="1.74"
        fill="#59d3ff"
        opacity="0.1"
      />
      <path
        d="M303.42,778s-37.3,19.27-18,42c0,0,1.81,5,7.06,4.58,0,0-1.05-1.91,3-3.43a19.57,19.57,0,0,0,4-2.14,9.49,9.49,0,0,0,3.61-4.82h0s7.63-10.21,1.72-29.1c0,0,.76-5.34.09-6.2L300.32,785s4.69,3.14,5.22,7.76c0,0-4.88-7.75-5.94-6.87-.21.18-2.25,3.4-2.25,3.4s8.12,5.51,8.73,12.66c0,0-4.58-10-9.52-11.45l-2.79,5.05s8.88,5.4,9.88,13.52c0,0-5.15-10.3-10.41-12.38l-2.08,5.33s8.55,5.44,9.34,12.2c0,0-7.15-11.3-9.73-11,0,0-1.61,5-1.4,6.55,0,0,6.05,4,6.16,8,0,0-5.58-7.05-6.44-6.58,0,0-.36,7.08,1.36,10.77,0,0-2.94-5.26-2.47-10.77A11.84,11.84,0,0,0,284.4,817s-1.61-3.9,3.69-7.48c0,0,.5-5.51,1.11-6.19,0,0-5.73,2.79-8.16,6.23,0,0,.89-5.12,8.66-7.66l2-5.4s-7.76,3.29-10.15,6.19c0,0,1.72-5.08,10.76-7.51l2.68-5s-6.9,2.32-10.26,5c0,0,2.61-4.36,11.09-6.37l2.18-3.11s-5,1.79-6.4,2.43-1.68.32-1.68.32a18.08,18.08,0,0,1,9-4.07S303.77,778.29,303.42,778Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <ellipse
        cx="169.3"
        cy="731.19"
        rx="21.92"
        ry="2.22"
        fill="#59d3ff"
        opacity="0.1"
      />
      <path
        d="M212,745s-28.58,14.76-13.82,32.16a5.49,5.49,0,0,0,5.41,3.51s-.8-1.46,2.27-2.63a15.52,15.52,0,0,0,3.08-1.64,7.31,7.31,0,0,0,2.77-3.7h0s5.84-7.82,1.31-22.29c0,0,.59-4.1.07-4.76l-3.47,4.77s3.59,2.41,4,5.94c0,0-3.74-5.93-4.55-5.26-.16.14-1.72,2.61-1.72,2.61s6.22,4.22,6.69,9.7c0,0-3.51-7.68-7.3-8.77l-2.13,3.86s6.79,4.14,7.56,10.36c0,0-3.95-7.89-8-9.48l-1.59,4.08s6.56,4.17,7.16,9.35c0,0-5.48-8.66-7.46-8.39,0,0-1.23,3.84-1.07,5,0,0,4.64,3.1,4.72,6.14,0,0-4.28-5.4-4.94-5,0,0-.27,5.42,1.05,8.25a16.49,16.49,0,0,1-1.9-8.25,9.12,9.12,0,0,0-2.74,4.41s-1.23-3,2.83-5.73c0,0,.38-4.22.85-4.74,0,0-4.39,2.14-6.25,4.77,0,0,.68-3.92,6.63-5.87l1.51-4.14s-5.95,2.52-7.79,4.75c0,0,1.32-3.9,8.25-5.76l2.06-3.81s-5.29,1.78-7.87,3.81c0,0,2-3.35,8.5-4.88l1.67-2.39s-3.83,1.37-4.9,1.87-1.29.24-1.29.24a13.88,13.88,0,0,1,6.88-3.12S212.22,745.2,212,745Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M886.74,755.41S864.39,767,875.93,780.56a4.29,4.29,0,0,0,4.23,2.74s-.63-1.14,1.78-2.06a11.56,11.56,0,0,0,2.41-1.28,5.72,5.72,0,0,0,2.16-2.89h0s4.57-6.12,1-17.43c0,0,.45-3.2.05-3.72l-2.71,3.72s2.81,1.89,3.13,4.66c0,0-2.93-4.65-3.56-4.12-.13.11-1.35,2-1.35,2s4.87,3.3,5.23,7.58c0,0-2.74-6-5.7-6.85L881,766s5.31,3.23,5.91,8.1c0,0-3.08-6.17-6.24-7.42l-1.24,3.2s5.12,3.25,5.6,7.31c0,0-4.29-6.78-5.83-6.56a16.37,16.37,0,0,0-.84,3.92s3.62,2.42,3.69,4.8c0,0-3.35-4.22-3.86-3.94,0,0-.22,4.24.81,6.45a13,13,0,0,1-1.48-6.45,7.12,7.12,0,0,0-2.14,3.45s-1-2.34,2.21-4.48c0,0,.3-3.3.66-3.71,0,0-3.43,1.67-4.88,3.73,0,0,.53-3.07,5.18-4.59l1.18-3.23s-4.65,2-6.09,3.7c0,0,1-3,6.46-4.5l1.6-3a26.71,26.71,0,0,0-6.15,3s1.57-2.61,6.65-3.81l1.3-1.87s-3,1.08-3.83,1.46-1,.19-1,.19a10.82,10.82,0,0,1,5.38-2.44S886.94,755.61,886.74,755.41Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <ellipse
        cx="936.04"
        cy="795.71"
        rx="41.75"
        ry="3.49"
        fill="#59d3ff"
        opacity="0.1"
      />
      <path
        d="M1004.47,736a17.44,17.44,0,0,0-2.28,4.3c-.14.37-.27.8-.41,1.21a4.46,4.46,0,0,0-.8-.28,11,11,0,0,0-3.56-.3c0-.47.05-.95.07-1.47.14-5.27-.48-12.62-5.51-9.5-4.82,3-1.38,8,1.73,11.2.27.28.54.54.8.79-2.83,2-3.38,6.73-3.85,11.64s-4.64,10.28-7.4,13.33l-.79.85a10.12,10.12,0,0,0-8-2.07c-.12-.43-.24-.88-.38-1.35-2.23-8.09-6.88-22.1-12.82-25.17.26-.31.52-.64.79-1,2.52-3.3,5.35-8.19,1.16-9.44s-4.56,4.24-4.33,8.36q0,.78.12,1.47a6.15,6.15,0,0,0-4.39,2.14l-.64-.77c-3.4-4-9.64-10.37-11.52-5.56-1.76,4.48,3.72,10.3,7.58,13.67l.25.21c-2.6,10.51,8.71,19.08,14.8,22.83l.79.48c-8.4,9.9-13.58,28.46-13.58,28.46l23.52,4.2s15.59-13.46,13.6-26.1l.16,0c15.58-3.12,19.13-19.74,16.7-29.61l.27-.11a17.65,17.65,0,0,0,7.22-5.46C1018.09,736.87,1009,730,1004.47,736Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M1004.47,736a17.44,17.44,0,0,0-2.28,4.3c-.14.37-.27.8-.41,1.21a4.46,4.46,0,0,0-.8-.28,11,11,0,0,0-3.56-.3c0-.47.05-.95.07-1.47.14-5.27-.48-12.62-5.51-9.5-4.82,3-1.38,8,1.73,11.2.27.28.54.54.8.79-2.83,2-3.38,6.73-3.85,11.64s-4.64,10.28-7.4,13.33l-.79.85a10.12,10.12,0,0,0-8-2.07c-.12-.43-.24-.88-.38-1.35-2.23-8.09-6.88-22.1-12.82-25.17.26-.31.52-.64.79-1,2.52-3.3,5.35-8.19,1.16-9.44s-4.56,4.24-4.33,8.36q0,.78.12,1.47a6.15,6.15,0,0,0-4.39,2.14l-.64-.77c-3.4-4-9.64-10.37-11.52-5.56-1.76,4.48,3.72,10.3,7.58,13.67l.25.21c-2.6,10.51,8.71,19.08,14.8,22.83l.79.48c-8.4,9.9-13.58,28.46-13.58,28.46l23.52,4.2s15.59-13.46,13.6-26.1l.16,0c15.58-3.12,19.13-19.74,16.7-29.61l.27-.11a17.65,17.65,0,0,0,7.22-5.46C1018.09,736.87,1009,730,1004.47,736Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M957.65,742.76l-2.75,8s-1.53-1.08-3.46-2.78c-3.85-3.37-9.34-9.19-7.58-13.67,1.88-4.81,8.12,1.54,11.52,5.56C956.74,741.52,957.65,742.76,957.65,742.76Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M963.46,738.16a40.53,40.53,0,0,1-2.68,3.16,39,39,0,0,1-.49-4.24c-.23-4.12.2-9.59,4.33-8.36S966,734.86,963.46,738.16Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M998.93,739.43c-.09,2.65-.35,4.77-.35,4.77a34.92,34.92,0,0,1-3.43-3.07c-3.11-3.23-6.55-8.21-1.73-11.2C998.45,726.81,999.07,734.16,998.93,739.43Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M1015.17,742.9a17.69,17.69,0,0,1-7.21,5.46,22.49,22.49,0,0,1-2.42.88l-3.24-4.55a32.25,32.25,0,0,1,1.33-4.42,17.44,17.44,0,0,1,2.28-4.3C1010.39,730,1019.53,736.87,1015.17,742.9Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M955.38,739.92c1.36,1.6,2.27,2.84,2.27,2.84l-2.75,8s-1.53-1.08-3.46-2.78a15.81,15.81,0,0,1,3.1-7.07A13.1,13.1,0,0,1,955.38,739.92Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M963.46,738.16a40.53,40.53,0,0,1-2.68,3.16,39,39,0,0,1-.49-4.24A5.55,5.55,0,0,1,963.46,738.16Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M977,770.12l-6.84,3s-1.5-.72-3.65-2.06c-7.18-4.42-21.64-15.55-12-28.67s17.77,10.41,21,21.92C976.46,767.76,977,770.12,977,770.12Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <path
        d="M995.15,741.13a5.6,5.6,0,0,1,3.78-1.7c-.09,2.65-.35,4.77-.35,4.77A34.92,34.92,0,0,1,995.15,741.13Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M1008,748.36a22.49,22.49,0,0,1-2.42.88l-3.24-4.55a32.25,32.25,0,0,1,1.33-4.42C1005.72,741.49,1007.26,744.53,1008,748.36Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M991,778.08c-.38.08-.77.15-1.16.2-22.92,3.49-7.56-8.88-7.56-8.88s1-.95,2.44-2.51c2.76-3,6.92-8.39,7.4-13.33.72-7.43,1.55-14.4,10.32-12.36S1012.68,773.73,991,778.08Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <rect x="911.74" y="784.77" width="43.81" height="11.52" fill="#d4dfec" />
      <rect x="904.77" y="747.33" width="57.24" height="40.2" fill="#d4dfec" />
      <rect x="911.74" y="784.77" width="43.81" height="11.52" opacity="0.1" />
      <rect x="904.77" y="747.33" width="57.24" height="40.2" opacity="0.1" />
      <rect x="914.62" y="784.77" width="43.81" height="11.52" fill="#d4dfec" />
      <path
        d="M975.49,764.32c1,3.44,1.49,5.8,1.49,5.8l-6.84,3s-1.5-.72-3.65-2.06C969.17,767.67,972.2,765.11,975.49,764.32Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M991,778.08c-.38.08-.77.15-1.16.2-22.92,3.49-7.56-8.88-7.56-8.88s1-.95,2.44-2.51C989,770.32,990.75,774.18,991,778.08Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M953.7,800s12.84-46,30.84-31.81-7.32,36-7.32,36Z"
        transform="translate(-35 -50.4)"
        fill="#59d3ff"
      />
      <circle cx="925.18" cy="699.21" r="1.44" opacity="0.1" />
      <circle cx="925.06" cy="705.93" r="1.44" opacity="0.1" />
      <circle cx="966.82" cy="700.53" r="1.44" opacity="0.1" />
      <circle cx="933.22" cy="734.97" r="1.44" opacity="0.1" />
      <circle cx="963.82" cy="711.69" r="1.44" opacity="0.1" />
      <circle cx="948.94" cy="726.57" r="1.44" opacity="0.1" />
      <circle cx="930.1" cy="702.09" r="1.44" opacity="0.1" />
      <circle cx="962.86" cy="704.85" r="1.44" opacity="0.1" />
      <circle cx="957.94" cy="716.01" r="1.44" opacity="0.1" />
      <circle cx="942.82" cy="733.89" r="1.44" opacity="0.1" />
      <circle cx="939.7" cy="726.81" r="1.44" opacity="0.1" />
      <circle cx="932.26" cy="710.85" r="1.44" opacity="0.1" />
      <rect x="914.62" y="784.77" width="43.81" height="4.21" opacity="0.1" />
      <rect x="907.66" y="747.33" width="57.24" height="40.2" fill="#d4dfec" />
      <circle cx="944.74" cy="740.37" r="1.44" opacity="0.1" />
      <circle cx="936.1" cy="742.17" r="1.44" opacity="0.1" />
      <path
        d="M872.28,624.13c-1.2-.86-1.7-2.93-1.88-5,0-.47-.07-.93-.09-1.37a5,5,0,0,0,1.39-1.26c2.37-3.36-3.29-15.55-3.29-15.55s2.19-6.36,0-11.84-3.19-6.54-3.19-6.54-7.4-15.2-6.3-17-1.83-16-4-18.85a41.54,41.54,0,0,0-2.92-3.54s.37-6.18-2.74-11-6.57-18.2-6.57-18.2-3.83-12.55-6.57-17a19,19,0,0,0-4-4.11c.43-2,1.42-4.65-1.42-20.33-1.16-6.44.65-10.28,2.14-16.65s1.17-13.74-3.4-18.55-11.66-5.71-17.33-9c-5-2.89-9.45-7.78-15.29-7.69-4.29.07-4.28.74-8.23,2.35-6.83,2.78-14.51,1.94-21.45,4.24-6.24,2.07-14.17,8.87-12.28,16.08a7.9,7.9,0,0,0,2.3,4.28c1.35,1.23,3,1.24,4.85.87,0,.12,0,.23-.07.35a18.47,18.47,0,0,0-.24,3c0,10.69,8.91,19.37,19.93,19.44.06.23.11.47.17.71.15.64.29,1.28.43,1.94-.52.69-1.06,1.38-1.57,2.07a20.08,20.08,0,0,0-3,5.33c-5.78,1.18-15.47,3.09-17,5.59-2,3.36-10.22,20-9.31,27.57.05.42.09,1,.13,1.6,0,0-5.06,9-5.79,11.83s-2.37,13.43-5.48,15.9-9.49,10.43-8.58,12-8.58,3.53-8.58,3.53-6.38,2.47-6,4.42c.11.59-.34,1.15-1,1.69-7.26-2.39-16.51-4-23.68-.36-10,5.07,7.54,8.56,18,10.09,1.72.26,3.24.46,4.42.6.08.34.41.64,1.25.93.66.23,1.64.59,2.78,1l.42-1.3c3.47,1.23,12.94,5.06,12.94,5.06s8.22,1.34,10.59-3.43c1-1.93,3.73-5,6.7-8l-.33,1.07-6.92,22.83s-10.95,17-10.4,20.67-3.47,13.08-4.38,14-10,27.74-14.79,29.51-11.14,7.95-9,9.9,11,8.3,15,6.18,11,1.77,11,1.77,7.66-1.26,13.9,1.74c.07.69.15,1.44.23,2.23.65,6,1.71,14.29,2.84,16.7,1.83,3.89,3.47,10.78,2,13.43s1.28,53.19,4,61.85c2.14,6.78,5.07,17.69,4.57,24.81-.3,4.33-.48,8.66-.51,13,0,.24,0,.48,0,.72s-.17.38-.25.58l0,.39a35.91,35.91,0,0,0-1.59,4.61s-4.71,11.84-3.12,14.93a2.77,2.77,0,0,0,.75.87c2.27,1.82,8,2.21,10,2.29l-.09,3h2.69s.07-3,.25-6.74a18.4,18.4,0,0,0,1.16-6.58,26.91,26.91,0,0,1,2.4-11.37s.06-.31.12-.81h0a20.08,20.08,0,0,0,.17-3.11,11,11,0,0,0-1-5.29,11.91,11.91,0,0,1,.2-3.23c.73-2.65-1.1-21.2-1.1-21.2l3.1-34.11s1.83-26.33,1.1-33.22a21.9,21.9,0,0,1,.13-5.54,178.82,178.82,0,0,0,2-22.62c0-.71,0-1.41,0-2.12,6.64,2.28,17.9.41,17.9.41s2.62-.06,6.1,0c.09.72.19,1.43.29,2.12.53,3.71,1.16,7,1.81,8.41,1.82,3.89,3.47,10.78,2,13.43s1.27,53.19,4,61.85c2.15,6.78,5.08,17.68,4.58,24.81-.3,4.32-.48,8.65-.51,13V806c-.09.19-.18.38-.26.58s0,.27,0,.39A36.45,36.45,0,0,0,808,811.6s-4.72,11.85-3.12,14.94a2.63,2.63,0,0,0,.75.86c2.27,1.83,8,2.21,10,2.29l-.09,3h2.69s.07-3,.25-6.74a18.4,18.4,0,0,0,1.16-6.58A27,27,0,0,1,822,808a20.75,20.75,0,0,0,.29-3.9,10.94,10.94,0,0,0-1.05-5.32,12.29,12.29,0,0,1,.2-3.22c.73-2.65-1.09-21.21-1.09-21.21l3.1-34.1s1.83-26.33,1.09-33.22a22.33,22.33,0,0,1,.14-5.54,178.27,178.27,0,0,0,2-21.49c0-.72,0-1.43,0-2.15.66-.81,2-1.45,5.7-2.69,6.39-2.12,19.17-12.73,24.28-13.43s9.67-4.07,8.21-6.72-9.49-4.42-8.76-8.48-4.93-6.54-7.48-13.25-13.7-12-13.88-17S824.23,596,824.23,596s-10.39-17.28-12.69-27.84c0-.24-.09-.46-.13-.68l.13,0a19.12,19.12,0,0,1-.38-2.4c0-.23.05-.47.09-.68l-.14,0v-.38s0,0,0-.07a1.64,1.64,0,0,1,.22-.14l.6-.35-.2.08a19.8,19.8,0,0,0,3.31-2.7,14.7,14.7,0,0,0,3.81-5.32,27,27,0,0,0,1.49-7l1.3-2c1.26,5.27,3.1,12.83,3.68,14.52A147.33,147.33,0,0,1,831.9,583a74.59,74.59,0,0,0,8,20.68s9.31,12.19,16.43,12.72,3.11,2.47,4.2,2.83l.31.07.11,1.43.31,4.15s7.3,29.69,15.52,25.45S875,626.07,872.28,624.13Z"
        transform="translate(-35 -50.4)"
        fill="url(#868cab57-2b4d-4e57-8adc-c5cfcad099b7)"
      />
      <path
        d="M873.24,650.46c-7.9,4.22-14.92-25.26-14.92-25.26l-.3-4.13-.57-7.81,9.65,1.23a29.46,29.46,0,0,0,0,5.07c.17,2,.66,4.09,1.81,4.93C871.48,626.43,881.13,646.25,873.24,650.46Z"
        transform="translate(-35 -50.4)"
        fill="#a1616a"
      />
      <path
        d="M754.21,822.6l.67-.51A3.6,3.6,0,0,1,754.21,822.6Z"
        transform="translate(-35 -50.4)"
        fill="#a1616a"
      />
      <path
        d="M774.1,660.64v20.14q0,1.31,0,2.61a184,184,0,0,1-2,22.47,22.45,22.45,0,0,0-.13,5.49c.7,6.85-1,33-1,33l-3,33.87s1.75,18.42,1,21a12.74,12.74,0,0,0-.19,3.21c.1,3,.62,6.85.79,8l0,.35-.11.08-14.67,11.19c2.34-2.13,2.94-7.09,2.93-11.69,0-.5,0-1,0-1.5q0-6.45.5-12.9c.48-7.07-2.34-17.9-4.4-24.64-2.63-8.59-5.27-58.78-3.86-61.41s-.18-9.48-1.93-13.34C747,694.22,746,686,745.4,680c-.38-3.64-.61-6.4-.61-6.4Z"
        transform="translate(-35 -50.4)"
        fill="#a1616a"
      />
      <path
        d="M805.26,818.1l.72-.54A4.23,4.23,0,0,1,805.26,818.1Z"
        transform="translate(-35 -50.4)"
        fill="#a1616a"
      />
      <path
        d="M825.15,656.14v20.14c0,1.24,0,2.49,0,3.73a184.06,184.06,0,0,1-1.93,21.35,22.44,22.44,0,0,0-.13,5.49c.7,6.85-1,33-1,33l-3,33.87s1.76,18.42,1.06,21a12.24,12.24,0,0,0-.19,3.2c.1,3,.63,6.91.79,8,0,.22.05.33.05.33l-.11.08h0L806,817.52c2.27-2.18,2.86-7.08,2.85-11.62,0-.5,0-1,0-1.51,0-4.3.2-8.6.49-12.9.47-7.07-2.34-17.89-4.4-24.63-2.64-8.59-5.27-58.78-3.86-61.41s-.18-9.48-1.93-13.34c-.63-1.36-1.23-4.67-1.75-8.35-.93-6.68-1.59-14.63-1.59-14.63Z"
        transform="translate(-35 -50.4)"
        fill="#a1616a"
      />
      <path
        d="M797.75,465.17l-.15.23a19.26,19.26,0,0,1-13.35,8,16.56,16.56,0,0,1-2.35.16c-.06-.24-.11-.48-.17-.71-1.15-5-2.37-9-2.37-9s1.31-1.89,3.22-4.3c5.19-6.56,14.75-16.93,14-3.07a23.77,23.77,0,0,0,1,8.31C797.65,464.86,797.69,465,797.75,465.17Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M801.18,453.5a19.29,19.29,0,0,1-16.93,19.15,18.66,18.66,0,0,1-2.38.15h-.14a19.3,19.3,0,1,1,19.45-19.3Z"
        transform="translate(-35 -50.4)"
        fill="#a1616a"
      />
      <path
        d="M819.9,509.74l-18.72,16s-20.41-29.12-18-35.09c.77-1.87.68-5.19.19-8.89-.27-2-.66-4.21-1.1-6.29-.13-.65-.27-1.29-.41-1.92-.06-.24-.11-.48-.17-.71-1.15-5-2.37-9-2.37-9s1.31-1.89,3.22-4.3c5.19-6.56,14.75-16.93,14-3.07a23.77,23.77,0,0,0,1,8.31c0,.16.09.32.15.47,2.66,8.18,9.14,14.71,14.12,18.76a55.84,55.84,0,0,0,6.45,4.58Z"
        transform="translate(-35 -50.4)"
        fill="#a1616a"
      />
      <path
        d="M744.79,673.63l29.31-13v20.14q0,1.31,0,2.61a10.09,10.09,0,0,1-1.9-.89c-5.79-3.58-13-.8-13.51-.8s-6.32,2.46-12.46-1.23c-.27-.16-.54-.31-.8-.44C745,676.39,744.79,673.63,744.79,673.63Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M825.15,656.14v20.14c0,1.24,0,2.49,0,3.73a10.7,10.7,0,0,0-1,2.21c-1.06,2.46-8.25,3.34-14.57,2.3a90.21,90.21,0,0,0-12.11-.76c-.93-6.68-1.59-14.63-1.59-14.63Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M853.94,661.87c-4.92.7-17.2,11.23-23.34,13.34s-5.44,2.45-6.49,4.91-8.25,3.33-14.57,2.29-18.25-.71-18.25-.71S778,684,772.17,680.39s-13-.8-13.51-.8-6.32,2.46-12.46-1.23-14.39-2.28-14.39-2.28-6.67-3.86-10.53-1.75-12.28-4.21-14.39-6.14,4-8.07,8.6-9.83,13.34-28.43,14.21-29.3,4.74-10.18,4.21-13.86,10-20.54,10-20.54L750.57,572l2-7,.08-4.17c0-1.88.09-4.29.14-7,.18-11.2.37-27.81,0-35.32-.06-1.16-.12-2.1-.2-2.78-.88-7.54,7-24,8.95-27.37,1.44-2.49,10.76-4.38,16.31-5.55a35.69,35.69,0,0,0,3.92-.94,4.58,4.58,0,0,1,1.54-.12c5.24.21,20.69,3.45,20.69,3.45-1.4,42.29,1.41,34.92,1.41,34.92,4.56-3.51,1.75-34.57,1.75-34.57,2.28,1.05,4.61-1.59,4.61-1.59l8.9,3.69a88.06,88.06,0,0,1,7.85,5.31,23.66,23.66,0,0,1,5.49,5.4c2.63,4.39,6.32,16.85,6.32,16.85l-3.16,5c-2.76,4.43-7,11.24-11.35,18.14l-7.72,12.29c-3.45,5.48-6.26,9.93-7.43,11.74a4.37,4.37,0,0,0-.55,1.41,7.35,7.35,0,0,0-.13,1,15.73,15.73,0,0,0,.41,4.16c2.21,10.48,12.2,27.65,12.2,27.65s10,15.26,10.18,20.17,10.88,10.18,13.34,16.85,7.89,9.12,7.19,13.16,7,5.79,8.42,8.42S858.85,661.17,853.94,661.87Z"
        transform="translate(-35 -50.4)"
        fill="#fa595f"
      />
      <path
        d="M867.08,619.56c-2.71,1.83-7.48,1.76-9.06,1.51l-.57-7.81,9.65,1.23A29.46,29.46,0,0,0,867.08,619.56Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M833.23,510.09l7.2,5.09s3.33,13.33,6.31,18.07,2.63,10.88,2.63,10.88a38,38,0,0,1,2.81,3.51c2.11,2.81,4.91,16.9,3.86,18.72s6.06,16.9,6.06,16.9,1,1,3.07,6.49,0,11.76,0,11.76,5.44,12.11,3.16,15.44-9.66,3-10.71,2.63,2.81-2.28-4-2.81-15.8-12.63-15.8-12.63a75.44,75.44,0,0,1-7.72-20.53,151.12,151.12,0,0,0-6.31-21.76c-.88-2.63-4.74-19.65-4.74-19.65Z"
        transform="translate(-35 -50.4)"
        fill="#fa595f"
      />
      <path
        d="M779.36,510.09s-.53,40.71-5.44,48.78Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M807.79,524.48s-4.56,40.71-8.16,42.81S807.79,524.48,807.79,524.48Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M801.18,518.69s-1.11,38.39-6.9,42.18S801.18,518.69,801.18,518.69Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M750.76,591.33s-7.26,21.23-6.44,30S750.76,591.33,750.76,591.33Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M810.5,570.35c-9.5,2.13-35.2,5.95-57.8-8.11,0-1.88.09-4.29.14-7,8.58,4.72,32.68,17,44.95,13.56,6.12-1.75,10-2.86,12.43-3.58A13.22,13.22,0,0,0,810.5,570.35Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M810.5,568.25c-9.5,2.12-35.2,5.94-57.8-8.11,0-1.88.09-4.3.14-7,8.58,4.72,32.68,17,44.95,13.56,6.12-1.74,10-2.86,12.43-3.57A13.23,13.23,0,0,0,810.5,568.25Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M810.5,569c-9.5,2.12-35.2,5.94-57.8-8.11,0-1.88.09-4.29.14-7,8.58,4.72,32.68,17,44.95,13.56,6.12-1.74,10-2.86,12.43-3.57A13.23,13.23,0,0,0,810.5,569Z"
        transform="translate(-35 -50.4)"
        fill="#605d82"
      />
      <path
        d="M810.5,569c-9.5,2.12-35.2,5.94-57.8-8.11,0-1.88.09-4.29.14-7,8.58,4.72,32.68,17,44.95,13.56,6.12-1.74,10-2.86,12.43-3.57A13.23,13.23,0,0,0,810.5,569Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M769.61,810.47c0,.23-.05.38-.06.43l-14.67,11.19c2.34-2.13,2.94-7.09,2.93-11.69,0-.5,0-1,0-1.5a29.61,29.61,0,0,1,5.42-8.66c2.5-.65,4.07,0,5,1.13,0,.11,0,.22,0,.32a4.6,4.6,0,0,1,.52.78C770.22,805,769.8,809.13,769.61,810.47Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M768.47,804.79l-11.07,7.6s.07-.89.17-2.2a30.3,30.3,0,0,1,5.67-9.25c2.5-.64,4.07,0,5,1.13C768.33,803.71,768.47,804.79,768.47,804.79Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M769.54,811.62a27.6,27.6,0,0,0-2.3,11.3,17.44,17.44,0,0,1-2.35,9.11,7.82,7.82,0,0,1-.77,1.11s-7.69-.06-10.38-2.29A2.63,2.63,0,0,1,753,830c-1.54-3.07,3-14.83,3-14.83,2.38-9.07,7.22-13.91,7.22-13.91C771.85,799,769.54,811.62,769.54,811.62Z"
        transform="translate(-35 -50.4)"
        fill="#5a5773"
      />
      <path
        d="M764.89,832a7.82,7.82,0,0,1-.77,1.11s-7.69-.06-10.38-2.29c1.32-4.38,5.55-17.63,7.52-15.38S764.42,827.77,764.89,832Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M763.83,816.29l-.53,19.86h2.58s.41-17.42,1.57-19.86S763.83,816.29,763.83,816.29Z"
        transform="translate(-35 -50.4)"
        fill="#5a5773"
      />
      <path
        d="M820.66,806l-.06.41h0L806,817.52c2.27-2.18,2.86-7.08,2.85-11.62,0-.5,0-1,0-1.51a29.57,29.57,0,0,1,5.41-8.65c2.5-.65,4.08,0,5.05,1.12,0,.12,0,.22,0,.33a4.16,4.16,0,0,1,.52.77C821.28,800.53,820.85,804.67,820.66,806Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M819.52,800.28l-11.07,7.61s.07-.89.18-2.2a30,30,0,0,1,5.66-9.25c2.5-.64,4.07-.05,5.05,1.13C819.38,799.21,819.52,800.28,819.52,800.28Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M820.6,807.12a27.44,27.44,0,0,0-2.31,11.3,17.44,17.44,0,0,1-2.35,9.11,8.68,8.68,0,0,1-.77,1.11s-7.69-.06-10.38-2.29a2.76,2.76,0,0,1-.72-.86c-1.53-3.07,3-14.83,3-14.83,2.38-9.07,7.22-13.91,7.22-13.91C822.9,794.52,820.6,807.12,820.6,807.12Z"
        transform="translate(-35 -50.4)"
        fill="#5a5773"
      />
      <path
        d="M815.94,827.53a8.68,8.68,0,0,1-.77,1.11s-7.69-.06-10.38-2.29c1.32-4.38,5.55-17.64,7.52-15.39S815.47,823.27,815.94,827.53Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M814.89,811.79l-.54,19.85h2.58s.41-17.41,1.57-19.85S814.89,811.79,814.89,811.79Z"
        transform="translate(-35 -50.4)"
        fill="#5a5773"
      />
      <path
        d="M837.88,525.71c-.12,5-2.85,10.33-7.64,11.82-1.4.43-2.89.53-4.32.82a9.25,9.25,0,0,0-2,.61c-3.07,1.41-4.6,4.91-5.22,8.23-.22,1.14-.36,2.29-.5,3.45a24.79,24.79,0,0,1-1.37,6.47,16.38,16.38,0,0,1-6.74,7.68,43.4,43.4,0,0,1-11.19,4.68,25.15,25.15,0,0,0,3-20.9c-.64-2.05-2-4.34-4.17-4.28-1.69.05-2.9,1.55-4.16,2.69-6.2,5.58-15.9,3.09-23.75.28,14-14.23,17.89-37.34,9.45-55.39a18.28,18.28,0,0,1-1.72-4.47,9.32,9.32,0,0,1,.43-4.62,20.48,20.48,0,0,1,2.84-5.29c.49-.69,1-1.37,1.52-2.06.67-.91,1.34-1.83,1.94-2.78a15.29,15.29,0,0,0,2-4.33c.89-3.4-.36-7.7-3.65-8.86l-.18-.07c-3.64-1.14-4.77-1.48-7.25-4.4-1.66-1.94-2.6-5-5.44-5.57-2.18-.45-4.62.52-6.91,1.11a19.31,19.31,0,1,1,34.8,14.17c2.56,8.4,9.19,15.1,14.27,19.23l8.9,3.69a88.06,88.06,0,0,1,7.85,5.31,114.82,114.82,0,0,0,5.66,18.29,64.45,64.45,0,0,1,3,9A22.15,22.15,0,0,1,837.88,525.71Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M783.1,458.69c3.42,1.07,4.74,5.47,3.83,8.93s-3.36,6.26-5.43,9.17-3.91,6.39-3.28,9.91a18.28,18.28,0,0,0,1.72,4.47c8.44,18.05,4.5,41.15-9.45,55.39,7.85,2.81,17.56,5.3,23.75-.28,1.26-1.14,2.47-2.64,4.16-2.69,2.15-.07,3.54,2.23,4.17,4.28a25.13,25.13,0,0,1-3,20.89c7.23-2.1,15.17-5.35,17.94-12.35,1.24-3.13,1.24-6.61,1.86-9.93s2.15-6.81,5.22-8.22c2-.9,4.25-.79,6.32-1.43,4.79-1.49,7.52-6.81,7.64-11.82s-1.8-9.82-3.6-14.49c-10-26-.6-5.17-6.08-36.46-1.12-6.39.63-10.21,2.06-16.53s1.12-13.64-3.27-18.42-11.21-5.67-16.66-8.91c-4.83-2.88-9.08-7.73-14.7-7.64-4.12.06-4.11.73-7.91,2.33-6.57,2.76-13.94,1.93-20.62,4.21-6,2.06-13.62,8.8-11.8,16,2.45,9.69,9.17,2.56,14.41,3.65,2.84.6,3.78,3.62,5.44,5.57C778.34,457.2,779.46,457.55,783.1,458.69Z"
        transform="translate(-35 -50.4)"
        fill="#4a4347"
      />
      <path
        d="M720,576.89s-2.84-.3-6.66-.89c-10-1.52-26.91-5-17.29-10,8.83-4.62,21-.7,28.12,2.44a62.28,62.28,0,0,1,5.92,3Z"
        transform="translate(-35 -50.4)"
        fill="#a1616a"
      />
      <path
        d="M773.22,515.88s-4.56,23-6.84,28.07-6,18.43-6,18.43-5.39,4.88-9.84,9.62l2-7,.08-4.17c0-1.88.09-4.29.14-7,.18-11.2.37-27.81,0-35.32.39-.73.64-1.18.64-1.18l3.55-5.63s5.79-15.44,9.12-19.83S773.22,515.88,773.22,515.88Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M722.79,573.84s-.51,2-1.37,4.7c-1.09-.44-2-.79-2.67-1-3-1,.53-2.28-.35-4.91-.75-2.26-2.14-1.55-3.74-2.18a43.71,43.71,0,0,1,3.39-4.07Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M756.37,511.67l-3.55,5.63S748,526.23,747.25,529,745,542.37,742,544.83s-9.13,10.35-8.25,11.93-8.25,3.51-8.25,3.51-6.14,2.46-5.79,4.39-5.09,3.51-3.16,4.91,3.69,0,4.57,2.63-2.64,3.87.35,4.92,12.81,5.16,12.81,5.16,7.89,1.33,10.17-3.41,15.27-16.49,15.27-16.49,3.68-13.34,6-18.43,6.85-28.07,6.85-28.07-3.69-28.43-7-24S756.37,511.67,756.37,511.67Z"
        transform="translate(-35 -50.4)"
        fill="#fa595f"
      />
      <path
        d="M746.37,556.94s-17.37,2.28-8.07,6.14,12.46,0,12.46,0Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M724.79,567.29s10.18-2.1,12.81,0S724.79,567.29,724.79,567.29Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M723.74,572.56s.7-1.76,4.21,0S723.74,572.56,723.74,572.56Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M838.58,589.32s1.06,16,5.37,16.52S838.58,589.32,838.58,589.32Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M847.8,553.1s.73,4.89-3.85,5.77S847.8,553.1,847.8,553.1Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M795.85,600.69s-.23,49.37,9.83,55.45Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M809.18,602.8S809,652.16,819,658.25Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M755.72,709.69a37,37,0,0,1,6.85,0C766.38,710,755.72,709.69,755.72,709.69Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M755.72,713.14a37,37,0,0,1,6.85,0C766.38,713.49,755.72,713.14,755.72,713.14Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M807.77,705.64a37,37,0,0,1,6.85,0C818.43,706,807.77,705.64,807.77,705.64Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <path
        d="M808.94,708.4a37,37,0,0,1,6.85,0C819.59,708.75,808.94,708.4,808.94,708.4Z"
        transform="translate(-35 -50.4)"
        opacity="0.1"
      />
      <g opacity="0.1">
        <path
          d="M774.18,544.83c14-14.23,17.89-37.33,9.45-55.39a18.28,18.28,0,0,1-1.72-4.47c-.63-3.52,1.2-7,3.28-9.91s4.53-5.71,5.43-9.17-.41-7.86-3.83-8.92c-3.64-1.14-4.77-1.49-7.25-4.41-1.66-1.94-2.6-5-5.44-5.56-5.24-1.09-12,6-14.41-3.66-1.38-5.42,2.65-10.6,7.3-13.69-5.81,2.41-12.53,8.81-10.81,15.58,2.45,9.69,9.17,2.57,14.41,3.66,2.84.59,3.78,3.62,5.44,5.56,2.49,2.92,3.61,3.27,7.25,4.41,3.42,1.06,4.74,5.46,3.83,8.92s-3.36,6.26-5.43,9.17-3.91,6.39-3.28,9.92a18.37,18.37,0,0,0,1.72,4.46c8.44,18.06,4.5,41.16-9.45,55.39,7.56,2.71,16.83,5.11,23,.31C787.82,549.09,780.42,547.06,774.18,544.83Z"
          transform="translate(-35 -50.4)"
        />
        <path
          d="M828.31,536.54a6.89,6.89,0,0,0-2,1.38c1.58-.39,3.25-.44,4.8-.93a9,9,0,0,0,3.26-1.82C832.38,535.73,830.2,535.67,828.31,536.54Z"
          transform="translate(-35 -50.4)"
        />
        <path
          d="M810.89,564.29a55.34,55.34,0,0,1-7.6,2.75,25.13,25.13,0,0,0,3-20.89c-.63-2-2-4.35-4.17-4.29a5.33,5.33,0,0,0-3.32,1.9c2,.07,3.37,2.29,4,4.28a25.13,25.13,0,0,1-3,20.89A43.92,43.92,0,0,0,810.89,564.29Z"
          transform="translate(-35 -50.4)"
        />
      </g>
    </svg>
  );
};
